// No direct PHP counterpart.
// JS discovery index for the sibling PHP unit files in this directory tree.
var requireFilter = require.context('.', true, /\.js$/)
var filters = []

requireFilter.keys().forEach(function(filename) {
	if (filename === './index.js') return

	var mod = requireFilter(filename)
	var filter = mod.default || mod

	if (filter && typeof filter.require === 'function' && typeof filter.run === 'function') {
		filters.push(filter)
	}
})

filters.sort(function(a, b) { return (a.priority || 50) - (b.priority || 50) })

export function queryFilters() {
	return filters
}
